import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import { BREAKPOINTS } from '@constants/layout.ts';
import styled from 'styled-components';

export const TopAlertBannerSection = styled.div`
    position: relative;
    margin-top: 40px;
    padding: 0 80px;

    @media (min-width: ${BREAKPOINTS.desktopFullHD}px) {
        position: absolute;
    }
`;

export const FailedAttemptsSection = styled.div<{ $isVisible?: boolean }>`
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight};
    border-radius: 8px;
    border: 1px solid ${BC.disabled};
    background: ${SC.neutral};
    color: ${TC.body};
    padding: 9px 0;
    text-align: center;
    width: 100%;
    margin-bottom: 8px;
    display: ${({ $isVisible = false }) => ($isVisible ? 'block' : 'none')};
`;

export const LockedUserWrapper = styled.div`
    display: flex;
`;

export const LockedUserTitle = styled.div`
    color: ${TC.body};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight};
    padding-right: 4px;
`;

export const LockedUserTitleContact = styled.div`
    color: ${TC.action};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM_LINK].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM_LINK].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_LINK].fontWeight};
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor: pointer;
`;
